"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = __importStar(require("@powerednow/complexData/entity"));
const date_1 = require("@powerednow/shared/modules/utilities/date");
let CompanySettingsEntity = class CompanySettingsEntity extends entity_1.default {
};
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true })
], CompanySettingsEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], CompanySettingsEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], CompanySettingsEntity.prototype, "setting_key_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], CompanySettingsEntity.prototype, "setting_value", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: date_1.getNow,
    })
], CompanySettingsEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', serverOnly: true })
], CompanySettingsEntity.prototype, "dt_updated", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', codeName: 'isDeleted', allowNull: false, defaultValue: false, serverOnly: true,
    })
], CompanySettingsEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], CompanySettingsEntity.prototype, "dt_deleted", void 0);
CompanySettingsEntity = __decorate([
    entity_1.EntityDecorator
], CompanySettingsEntity);
exports.default = CompanySettingsEntity;
//# sourceMappingURL=../../../../src/models/companySettings/entity.js.map